import Layout from "../../components/layout/Layout";


export default function NotFoundPage() {

    return (
        <Layout title="404 - Nie znaleziono">
            <div style={{
                padding: 20,
            }}>
                <h2>
                    404 - Nie znaleziono
                </h2>
            </div>
        </Layout>
    )
}